import formatProgramPrice from "@/lib/checkout-geo-pricing/formatProgramPrice";
import useTranslations from "@/i18n/useTranslations";

type PriceDisplayProps = {
  originalPrice: number;
  discountedPrice: number;
  currency: string;
};

export default function PriceDisplay({
  originalPrice,
  discountedPrice,
  currency,
}: PriceDisplayProps) {
  const t = useTranslations("Common");
  const hasDiscount =
    originalPrice != null &&
    discountedPrice != null &&
    originalPrice !== discountedPrice;

  return (
    <div className="flex flex-row items-center justify-center gap-2">
      <p className="text-center text-lg font-bold m-0">
        <span className="sr-only">
          {hasDiscount ? t("discountedPrice") : t("priceLabel")}
        </span>
        {formatProgramPrice(discountedPrice ?? originalPrice, currency)}
      </p>

      {hasDiscount && (
        <p className="text-center text-lg text-gray-500 line-through m-0 opacity-70">
          <span className="sr-only">{t("originalPrice")}</span>
          {formatProgramPrice(originalPrice, currency)}
        </p>
      )}
    </div>
  );
}
